module.exports = __webpack_public_path__ + "static/media/wedding-catering-2.2f4ea6db.jpg";